export default {
	title: 'Device Type List',
	actions: {
		add: 'Add',
		edit: 'Edit',
		delete: 'Delete',
		batchDelete: 'Batch Delete',
		save: 'Save',
		cancel: 'Cancel',
		confirm: 'Confirm'
	},
	messages: {
		deleteSuccess: 'Delete successful',
		actionSuccess: 'Operation successful'
	},
	labels: {
		deviceTypeList: 'Device Type List'
	},
	buttons: {
		add: 'Add',
		batchDelete: 'Batch Delete',
		edit: 'Edit',
		delete: 'Delete'
	},
	table: {
		id: 'id',
		deviceTypeName: 'Device Type Name',
		icon: 'Icon',
		accThreshold: 'Acceleration Threshold',
		speedThreshold: 'Speed Threshold',
		tempThreshold: 'Temperature Threshold',
		action: 'Action'
	},
	form: {
		placeholder: {
			name: 'Name'
		}
	},
	config: {
		gridLayout: 'Grid Layout',
		name: 'Name',
		icon: 'Icon',
		accThreshold: 'Acceleration Threshold',
		speedThreshold: 'Speed Threshold',
		tempThreshold: 'Temperature Threshold',
		remark: 'Remark',
		nameRequired: 'Required field cannot be empty'
	},
	dialog: {
		add: 'Add',
		update: 'Edit'
	}
}
